import { LinkItemSchema } from '@/views/sports/components/CompetitionsMenu/styles/LinkItem.styles';

export const linkItemStyles: LinkItemSchema = {
  link: {
    bgGradient: 'linear(to-b, alpha.500, alpha.300)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    h: '9',
    pl: '3',
    pr: '2',
    _hover: {
      textDecoration: 'none',
    },
    _last: {
      mb: 0,
    },
  },
  textCompetitionName: {
    color: 'alpha.900',
    fontFamily: 'accent',
    fontWeight: 'bold',
    fontSize: 'xs',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxW: '140px',
  },
  textMatchCount: {
    px: '1',
    fontSize: '2xs',
    fontWeight: 'bold',
    color: 'alpha.900',
    fontFamily: 'accent',
  },
};
